import "./App.css";
import Pages from "./Components/pages/Pages";
import axios from "axios";
import { toast } from "react-toastify";

function App() {
  localStorage.getItem("products") !== null
    ? localStorage.getItem("products")
    : localStorage.setItem("products", []);

  const url = localStorage.getItem("backEnd");

  const getToken = () =>
    localStorage.getItem("tokens") ? localStorage.getItem("tokens") : null;
  // Add a request interceptor
  axios.interceptors.request.use(
    function (config) {
      // Do something before request is sent
      config.headers.Authorization = `Bearer ${getToken()}`;
      // OR config.headers.common['Authorization'] = `Bearer ${your_token}`;
      config.baseURL = url;
      return config;
    },
    function (error) {
      // Do something with request error
      return Promise.reject(error);
    }
  );
  axios.interceptors.response.use(
    (response) => {
      // //debugger
      if (typeof response.data !== "object") {
        // alert(response.data);
        // return
      }
      return response;
    },
    (error) => {
      if (error.response) {
        // //debugger

        if (
          error.response.status === 401 &&
          window.location.pathname !== "/login"
        ) {
          // const NavigateTo =useNavigate();
          sessionStorage.clear();
          localStorage.clear();
          toast.error("لطفا وارد سامانه شوید");
          // NavigateTo("/login")
          setTimeout(() => {
            window.location.reload();
          }, 2000);
        }
        if (
          error.response.status === 401 &&
          window.location.pathname === "/login"
        ) {
          return error;
        }
      }
      return error;
    }
  );
  return <Pages />;
}

export default App;
